import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from "prop-types";

import {
    Box,
    Grid
} from '@mui/material';

const PREFIX = 'Banner';

const classes = {
    root: `${PREFIX}-root`,
    paper: `${PREFIX}-paper`,
    heading: `${PREFIX}-heading`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        flexGrow: 1,
    },

    [`& .${classes.paper}`]: {
        padding: theme.spacing(2),
        textAlign: 'left',
        color: "white",
        backgroundColor: theme.palette.primary.main,
    },

    [`& .${classes.heading}`]: {
        fontSize: "2.5rem"
    }
}));

function Banner(props) {

    return (
        (<Root>
            <div className={classes.root}>
            <Grid container spacing={0}>
                <Grid item xs={12} sm={12}>
                    <Box className={classes.paper}>
                        <Grid container spacing={0}>
                            <Grid item xs={3} sm={1}></Grid>
                            <Grid item xs={7} sm={8}>
                                <h1 className={classes.heading}>{props.title}</h1>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            </div>
        </Root>)
    );
}

Banner.propTypes = {
    title: PropTypes.any,
};

export default Banner;
